import { RootActions } from 'types/state';
import { FETCH_FORM_SUCCESS } from '@redux/modules/api/actionTypes';
import { RootActionTypes } from '@redux/modules/actionTypes';
import * as ActionTypes from '../actionTypes';
import { fetchFormSuccessSlice } from '../slices/fetchForm';

/**
 * Clears the SameSpouseConfirmed flag that is set on cohabitants.
 */
export const clearCohabitantsSameSpouseConfirmed = (relationships2: any = {}) => {
  if (!relationships2.Cohabitants) {
    return relationships2;
  }

  const cohabitants = relationships2.Cohabitants.CohabitantList;
  if (!cohabitants || !cohabitants.length) {
    return relationships2;
  }

  const cohabitantList = cohabitants.map((c: any) => {
    if (!c.Cohabitant) {
      return c;
    }
    c.Cohabitant.SameSpouseConfirmed = false; // eslint-disable-line no-param-reassign
    return c;
  });

  relationships2.Cohabitants.CohabitantList = cohabitantList; // eslint-disable-line no-param-reassign
  return relationships2;
};

const relationships = (state = {}, action: RootActions) => {
  let newState: any;
  switch (action.type) {
    case FETCH_FORM_SUCCESS:
      return fetchFormSuccessSlice(state, action, 'Relationships');

    case ActionTypes.UPDATE_APP:
      if (action.section !== 'Relationships') { return state; }
      newState = {
        ...state,
        [action.property]: action.values,
      };

      return newState;

    case ActionTypes.CLEAR_SAME_SPOUSE:
      newState = {
        ...state,
        // Not sure if this is actually being used or just a bug of old code.
        // Previously, this was being set via updateApplication and the tests
        // check for this.
        ClearSameSpouseConfirmed: true,
      };
      return clearCohabitantsSameSpouseConfirmed(newState);

    case RootActionTypes.authentication.LOGGED_OFF: {
      return {};
    }

    default:
      return state;
  }
};


export default relationships;
